import { z } from "zod"

import { PaginationSchema } from "../../shared/pagination_dtos"
import { QuerySchema } from "../../shared/query_dtos"
import { createSortSchema } from "../../shared/sort_dtos"

export const QRsortFields = ["name", "scans", "lastScannedAt"] as const
export const QRsSortSchema = createSortSchema(QRsortFields, "name", "asc")

export const GetQRsSchema = z.object({
  ...PaginationSchema.extend(QuerySchema.shape).extend(QRsSortSchema.shape).shape,
})

export const GetQRByIdSchema = z.object({ id: z.string().transform(BigInt) })

export const UpsertQRSchema = z.object({
  name: z.string(),
})
